import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SpeechRecognition from 'react-speech-recognition';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));